import { css } from '@emotion/react';
import { theme } from '@frontend/theme';
import type { ScheduleDefinitionCalendarEvent } from '../../../types';

interface Props {
  event: ScheduleDefinitionCalendarEvent;
}
export const ScheduleDefinitionEvent = ({ event }: Props) => {
  return <div data-event-type={event.eventType} css={containerStyle}></div>;
};

const containerStyle = css({
  padding: theme.spacing(0.5),
  background: theme.colors.white,
});
